import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { BarChart, Top5Point, Top5Seller } from '../index';
import { getReportCompetition } from '../../../../apis/api';
import CircularProgress from '@material-ui/core/CircularProgress';

// eslint-disable-next-line react/no-multi-comp
const Loading = () => (
    <div
        style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            paddingTop: '20px'
        }}>
        <CircularProgress />
    </div>
);

const Competition = ({ term = '', options = {} }) => {
    const { category1, category2, targetDate, compareDate } = options;
    const [dataset, setDataset] = useState({
        loading: false,
        data: {}
    });

    useEffect(() => {
        setDataset({
            loading: true,
            data: {}
        });
        getReportCompetition({
            term,
            category1,
            category2,
            targetDate,
            compareDate
        })
            .then(res => {
                setDataset({
                    loading: false,
                    data: res.data
                });
            })
            .catch(() => {
                setDataset({
                    loading: false,
                    data: {}
                });
            });
    }, [term, category1, category2, targetDate, compareDate]);

    if (dataset.loading) return <Loading />;

    return (
        <>
            <Grid item lg={4} md={4} xl={3} xs={12}>
                <BarChart term={term} data={dataset.data.categoryPoint} />
            </Grid>
            <Grid item lg={8} md={8} xl={9} xs={12}>
                <Top5Point term={term} data={dataset.data.platformPoint} />
            </Grid>
        </>
    );
};

export default Competition;
